module.exports = __webpack_public_path__ + "img/cut_gd3.32f0f83c.jpg";